import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"];

  requestUpdate(params) {
    Array.from(this.formTarget.elements).forEach((input) => {
      switch(input.name) {
        case "billing_profile[legal_name]":
          if (params.LegalName) input.value = params.LegalName;
          break;
        case "billing_profile[country_id]":
          if (params.Country) input.value = params.Country
          break;
        case "billing_profile[business_type]":
          if (params.BusinessType) input.value = params.BusinessType;
          break;
        case "billing_profile[registration_number]":
          if (params.RegistrationNumber) input.value = params.RegistrationNumber;
          break;
        case "billing_profile[vat_number]":
          if (params.VatNumber) input.value = params.VatNumber;
          break;
        case "billing_profile[city]":
          if (params.City) input.value = params.City;
          break;
        case "billing_profile[zipcode]":
          if (params.ZipCode) input.value = params.ZipCode;
          break;
        case "billing_profile[address_line_1]":
          if (params.AddressLine1) input.value = params.AddressLine1;
          break;
        case "billing_profile[capital]":
          if (params.Capital) input.value = params.Capital;
          break;
        case "billing_profile[registration_city]":
          if (params.RegistrationCity) input.value = params.RegistrationCity;
          break;
      }
    })
  }
}
